// Design tokens for the V2 "The Ticket" screens (FOYR-563), lifted from the
// Paper "Pre-Order / V2 · The Ticket" artboards. The accent is the
// restaurant's branding colour, exposed as the CSS custom properties below
// (see useBrandAccent); everything else is fixed.

export const V2_COLORS = {
  bg: "#FFFFFF",
  surface2: "#F7F7F8",
  border: "#E5E5E5",
  borderStrong: "#D9D9D9",
  text: "#0A0A0A",
  text2: "#6B6B6B",
  text3: "#A8A8A8",
  onText: "#FFFFFF",
  scrim: "rgba(10, 10, 10, 0.45)",
} as const;

export const V2_ACCENT_VAR = "--v2-accent";
export const V2_ON_ACCENT_VAR = "--v2-on-accent";
export const V2_DEFAULT_ACCENT = "#D7261E";
export const V2_DEFAULT_ON_ACCENT = "#FFFFFF";

/** The accent colour, with the default baked in for any unset var. */
export const V2_ACCENT = `var(${V2_ACCENT_VAR}, ${V2_DEFAULT_ACCENT})`;
export const V2_ON_ACCENT = `var(${V2_ON_ACCENT_VAR}, ${V2_DEFAULT_ON_ACCENT})`;

export const V2_FONTS = {
  sans: '"Geist", system-ui, -apple-system, "Segoe UI", sans-serif',
  mono: '"Geist Mono", ui-monospace, "SFMono-Regular", Menlo, monospace',
  serif: '"Instrument Serif", Georgia, "Times New Roman", serif',
} as const;

/** Horizontal page gutter used by every artboard. */
export const V2_GUTTER = 28;

/** Pages are designed at 390px; wider screens centre a phone-width column. */
export const V2_MAX_WIDTH = 480;
